import {
  onDisconnect,
  push,
  ref,
  serverTimestamp,
  set
} from 'firebase/database'
import { useEffect } from 'react'

import { database } from '@/ui/config/firebase'
import { useAuthContext } from '@/ui/contexts/AuthContext'

export function usePresence() {
  const { personaSession } = useAuthContext()

  useEffect(() => {
    const effect = async () => {
      if (!personaSession?.personaId) return

      try {
        const connectionsRef = await push(
          ref(database, `presence/${personaSession.personaId}/connections`)
        )
        const lastOnlineRef = ref(
          database,
          `presence/${personaSession.personaId}/lastOnline`
        )

        set(connectionsRef, true)

        onDisconnect(lastOnlineRef).set(serverTimestamp())
        onDisconnect(connectionsRef).remove()
      } catch (error) {
        console.error(error)
      }
    }

    effect()
  }, [personaSession?.personaId])
}
